import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

const ADD_PAGE_TAG_MUTATION = gql`
  mutation AddPageTag($input: PageTagInput!) {
    addPageTag(input: $input) {
      id
      name
      description
    }
  }
`;

export interface AddPageTagInput {
  slug: string;
  page_id: string;
  tag_id: string;
  version: string;
}

export interface AddPageTagResponse {
  addPageTag: {
    id: string;
    name: string | null;
    description: string | null;
  };
}

export async function addPageTagMutation(input: AddPageTagInput): Promise<AddPageTagResponse> {
  return graphqlClient.request<AddPageTagResponse>(ADD_PAGE_TAG_MUTATION, { input });
}
